import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import { Box } from '@material-ui/core';
import styles from './ModuleLibrary.module.css';
import { useTranslation } from 'react-i18next';

export default function ModuleTable({ moduleList, setSelectedModule }) {
  const { t } = useTranslation();
  const columns = [
    { field: 'serialNumber', headerName: t('serialNumber'), width: 170 },
    {
      field: 'carModel',
      headerName: t('carModel'),
      width: 180,
      valueFormatter: (params) => params.row.template.carModel
    },
    {
      field: 'OEM',
      headerName: t('OEM'),
      width: 180,
      valueFormatter: (params) => params.row.template.batteryCellManufacturer
    },
    { field: 'id', headerName: t('moduleId'), width: 300 }
  ];
  return (
    <Box className={styles.moduleTable}>
      <DataGrid
        columns={columns}
        rows={moduleList}
        pageSize={12}
        onRowClick={(e) => setSelectedModule(e.row)}
      />
    </Box>
  );
}
